'use client';

import { useEffect } from 'react';
import { Img } from '@chakra-ui/react';
import Script from 'next/script';

import { ClientConfig } from 'services/clientConfig';
import { getMarketingScriptVersion } from './getMarketingScriptVersion';

interface Props {
  isEnabled: boolean;
}

export const LinkedInInsight = (props: Props) => {
  const { isEnabled } = props;

  const clientConfig = ClientConfig.getInstance().getConfig();

  const ejectLinkedinInsight = () => {
    const linkedinSnippet = document.getElementById('linkedin-insight-snippet');
    const linkedinScript = document.getElementById('linkedin-insight-script');

    linkedinSnippet?.remove();
    linkedinScript?.remove();
  };

  useEffect(() => {
    if (isEnabled) return;

    ejectLinkedinInsight();
  }, [isEnabled]);

  useEffect(() => {
    return () => {
      ejectLinkedinInsight();
    };
  }, []);

  if (!isEnabled) return null;

  return (
    <>
      <Script
        id="linkedin-insight-snippet"
        key="linkedin-insight-snippet"
        defer
        strategy="lazyOnload"
        type="text/javascript"
        src={`/g/scripts/marketing/linkedin-insight.js?v=${getMarketingScriptVersion()}`}
      />

      <noscript id="linkedin-noscript">
        <Img
          height="1"
          width="1"
          style={{ display: 'none' }}
          alt="LinkedIn Insight"
          loading="lazy"
          src={`https://px.ads.linkedin.com/collect/?pid=${clientConfig.linkedinPartnerId}&fmt=gif`}
        />
      </noscript>
    </>
  );
};
